import React, { useEffect } from 'react'
import { makeStyles, useMediaQuery, useTheme, createStyles, Box, Chip, Button } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useHistory, Link } from 'react-router-dom'
import { useImageTranslation } from 'src/hooks'
import { selectItem, viewItemList } from 'src/utils/trackingCode'
import { ReactComponent as Suona } from 'src/mobile/assets/icons/suona.svg'
import { productCardData } from '../utils/constant'
import { ReactComponent as Return } from '../assets/icons/Return.svg'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      minWidth: 1350,
    },
    main: {
      maxWidth: 1200,
      margin: '0 auto',
      padding: theme.spacing(0, 2),
    },
    banner: {
      width: '100%',
      borderRadius: 10,
      marginTop: theme.spacing(4),
    },
    title: {
      fontSize: 23,
      fontWeight: 600,
      [theme.breakpoints.down('xs')]: {
        fontSize: 20,
      },
    },
    title_tips: {
      fontSize: 16,
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(2),
      lineHeight: 1.5,
      [theme.breakpoints.down('xs')]: {
        color: '#4B5563',
      },
    },

    hoverPointer: {
      cursor: 'pointer',
    },
    productCard: {
      width: 180,
      height: 180,
      borderTopLeftRadius: 8,
      borderBottomLeftRadius: 8,
    },
    productTitle: {
      fontWeight: 600,
      fontSize: 16,
    },
    productDetail: {
      color: '#4B5563',
      fontSize: 12,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      lineClamp: 2,
      WebkitBoxOrient: 'vertical',
    },
    swiperSlideChip: {
      borderRadius: theme.spacing(12.5),
      backgroundColor: '#F3F4F6',
      marginTop: theme.spacing(2),
      maxWidth: '100%',
      minHeight: 40,
      padding: 9.5,
      paddingLeft: 0,
      paddingRight: 0,
      color: '#4B5563',
      [theme.breakpoints.down('xs')]: {
        marginTop: theme.spacing(1.5),
        marginBottom: theme.spacing(2),
      },
    },
    back: {
      margin: '24px 0',
      borderRadius: '100px',
      width: '183px',
      height: '56px',
      fontSize: 16,
      [theme.breakpoints.down('xs')]: {
        width: '163px',
      },
    },
  }),
)

const Promotion = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const history = useHistory()
  const productCard = productCardData.map((item) => {
    return {
      ...item,
      img: tImage(item.imgmobile, 'webp'),
      name: t(item.name),
    }
  })

  useEffect(()=>{
    viewItemList('promotions_NEW330_productcard', 'Promotions NEW330 Product Card', productCard )
  },[])

  return (
    <Box width="100%">
      <Box className={classes.main}>
        <img src={tImage('program_banner', 'webp')} alt="" className={classes.banner} />
        <Box display="flex" justifyContent="space-between" alignItems="center" my={2}>
          <Box display="flex" alignItems="center">
            <Suona />
            <Box mt={0.2} ml={0.5} color="#F57457">
              {t('glossary. promotion_discount')}
            </Box>
          </Box>
          <Box color="#9CA3AF">21.02.2023</Box>
        </Box>
        <Box className={classes.title}>{t('promotion.Healthcheck')}</Box>
        <Box className={classes.title_tips}>{t('promotion.lading_title')}</Box>

        <Box>
          {productCard.map((item, index) => (
            <Box
              key="index"
              onClick={() => {
                selectItem('promotions_NEW330_productcard', 'Promotions NEW330 Product Card', item, index)
                history.push(`/${i18n.language}` + item.path)
              }}
            >
              <Box
                className={classes.hoverPointer}
                border="1px solid #E5E7EB"
                width="100%"
                borderRadius={8}
                mb={isMobile ? 3 : 4}
                display="flex"
              >
                {!isMobile && (
                  <img className={classes.productCard} src={item.img} alt="product info banner" />
                )}
                <Box mx={isMobile ? 2 : 3} position="relative">
                  <Box className={classes.productTitle} mb={1.5} mt={isMobile ? 2 : 3.5}>
                    {item.name}
                    {item.nameInclude && `(${t('glossary.included_Take2Prophecy')})`}
                  </Box>
                  <Box className={classes.productDetail}>{t(item.detail)}</Box>

                  <Box className={classes.swiperSlideChipBox}>
                    <Chip
                      classes={{ label: classes.swiperSlideChiplable, root: classes.swiperSlideChip }}
                      label={t('glossary.discount', { field: item.discountprice })}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>

        <Button
          variant="outlined"
          className={classes.back}
          component={Link}
          onClick={() => history.push('/promotion')}
          id="return"
        >
          <Return />
          <Box mr={0.5}>{t('common.back')}</Box>
        </Button>
      </Box>
    </Box>
  )
}

export default Promotion
